import { c as _c } from "react/compiler-runtime";
import React, { Fragment } from 'react';
import { BaseTable, BaseTableProps } from './components/base-table';
import { ColumnDefinitionInterface } from './types/column-interface';
import { calculateTableTotalWidth } from './utils';
export interface ColumnWithExtraHeaderInterface<T> extends ColumnDefinitionInterface<T> {
  extraHeader: React.ReactNode;
}
interface TableWithExtraHeadersProps<T> extends Omit<BaseTableProps<T>, 'columns'> {
  columns: ColumnWithExtraHeaderInterface<T>[];
}
export function TableWithExtraHeaders(t0) {
  const $ = _c(26);
  let columns;
  let props;
  if ($[0] !== t0) {
    ({
      columns,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = columns;
    $[2] = props;
  } else {
    columns = $[1];
    props = $[2];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let tableColumns;
  if ($[3] !== columns) {
    const visibleColumns = columns.filter(_temp);
    tableColumns = visibleColumns.map(_temp2);
    const totalWidth = calculateTableTotalWidth(tableColumns);
    t4 = "overflow-auto";
    const t5 = visibleColumns.length * 252;
    if ($[9] !== t5) {
      t3 = {
        minWidth: t5
      };
      $[9] = t5;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t1 = "bg-background-secondary main-transition-colors  \n          hover:border-brand-primary flex flex-col\n          items-start gap-4 rounded-t-lg border border-transparent px-6 py-4 \n          lg:flex-row lg:items-center lg:gap-0 lg:p-0\n          ";
    let t6;
    if ($[11] !== totalWidth) {
      t6 = (column_0, index) => {
        const widthPercent_0 = column_0.widthPercent || 25;
        return <Fragment key={`extraHeaderCell-${index}`}><div className="hidden truncate px-6 py-4 lg:table-cell" style={{
            flex: `${widthPercent_0 / totalWidth * 100}`
          }}>{column_0.extraHeader}</div><div className="w-full truncate lg:hidden lg:px-6 lg:py-2.5"><div className="flex items-center gap-3"><span className="text-text-primary whitespace-nowrap font-bold">{column_0.header}</span>{column_0.extraHeader}</div></div></Fragment>;
      };
      $[11] = totalWidth;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t2 = visibleColumns.map(t6);
    $[3] = columns;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = tableColumns;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    tableColumns = $[8];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== props || $[17] !== tableColumns) {
    t6 = <BaseTable columns={tableColumns} {...props} />;
    $[16] = props;
    $[17] = tableColumns;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t3 || $[20] !== t5 || $[21] !== t6) {
    t7 = <div style={t3}>{t5}{t6}</div>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t4 || $[24] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[23] = t4;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}
function _temp2(t0) {
  const {
    key,
    header,
    widthPercent,
    onRender,
    onRenderSmall,
    shouldRender
  } = t0;
  return {
    key,
    header,
    widthPercent,
    onRender,
    onRenderSmall,
    shouldRender
  };
}
function _temp(column) {
  return column.shouldRender !== false;
}